export default __webpack_public_path__ + "static/media/illust-communication.204dcf86.svg";